import React from 'react';
import { t } from '@lingui/core/macro';

import OverflowTextModal from '@rover/components/src/OverflowTextModal/OverflowTextModal';

import { sendSectionInteractionEvent } from '../../utils/sendSectionInteractionEvent';

const InfoAboutPet = ({
  info,
  sitterShortName,
}: {
  info: string;
  sitterShortName: string;
}): JSX.Element => {
  const title = t`Information ${sitterShortName} would like to know about your pet`;

  return (
    <OverflowTextModal
      title={title}
      text={info}
      onReadMore={() => {
        sendSectionInteractionEvent('requested-dog-info');
      }}
    />
  );
};

export default InfoAboutPet;
